import type { MarketingTranslator } from '@/i18n/marketing'
/** Static option content shared by the LC marketing inquiry forms. */

export interface InterestOption {
  readonly value: string
  readonly label: string
}

export interface FranchiseTypeOption {
  readonly value: 'academy' | 'tutoring'
  readonly label: string
}

export function getBriefingInterests(mt: MarketingTranslator) {
  const BRIEFING_INTERESTS: readonly InterestOption[] = [
    { value: 'franchise_terms', label: mt('briefing.BRIEFINGINTERESTS.0.label') },
    { value: 'marketing', label: mt('briefing.BRIEFINGINTERESTS.1.label') },
    { value: 'content', label: mt('briefing.BRIEFINGINTERESTS.2.label') },
    { value: 'curriculum', label: mt('briefing.BRIEFINGINTERESTS.3.label') },
    { value: 'class_method', label: mt('briefing.BRIEFINGINTERESTS.4.label') },
    { value: 'operation', label: mt('briefing.BRIEFINGINTERESTS.5.label') },
    { value: 'other', label: mt('briefing.BRIEFINGINTERESTS.6.label') },
  ] as const
  return BRIEFING_INTERESTS
}

export function getFranchiseTypes(mt: MarketingTranslator) {
  const FRANCHISE_TYPES: readonly FranchiseTypeOption[] = [
    { value: 'academy', label: mt('briefing.FRANCHISETYPES.0.label') },
    { value: 'tutoring', label: mt('briefing.FRANCHISETYPES.1.label') },
  ] as const
  return FRANCHISE_TYPES
}

export const INTEREST_OTHER_VALUE = 'other' as const
